module.exports = __webpack_public_path__ + "static/knowledge_sharing-4751fa66b2c79b7b36d5de9e1a6b7e4c.svg";